import { render } from "./CampaignRow.vue?vue&type=template&id=bdefc908&scoped=true"
import script from "./CampaignRow.vue?vue&type=script&lang=js"
export * from "./CampaignRow.vue?vue&type=script&lang=js"

import "./CampaignRow.vue?vue&type=style&index=0&id=bdefc908&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdefc908"]])

export default __exports__